import { testimonials } from '@/mocks/categories';

export default function TrustSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="flex items-center justify-center gap-2 mb-2">
            <span className="w-2 h-2 rounded-full bg-accent-500 inline-block"></span>
            <p className="text-xs font-medium text-accent-600 uppercase tracking-widest">Community Trust</p>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 leading-tight">
            What Our Users Say
          </h2>
          <p className="mt-2 text-sm text-foreground-500 max-w-md mx-auto">
            Join thousands who save time and money with our curated spreadsheets
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((t, idx) => (
            <article
              key={t.name}
              className={`bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60 ${
                idx === testimonials.length - 1 ? 'opacity-60' : ''
              }`}
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <span key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-sm text-primary-500"></i>
                  </span>
                ))}
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">{t.headline}</h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-4">{t.body}</p>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-full bg-accent-200 flex items-center justify-center">
                  <span className="text-xs font-semibold text-accent-700">{t.name.charAt(0)}</span>
                </div>
                <div>
                  <p className="text-xs font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-400">{t.role}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}